import React, { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col, Button, Spinner } from "reactstrap";
import CustomForm from "../../../custom/Forms/CustomForm";
import { useParams } from "react-router-dom";
import DownloadExcel, {
  formatNumber,
  getRecords,
} from "../../../services/api.service";

const ShortageReport = () => {
  const { id } = useParams;
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [expandedCategories, setExpandedCategories] = useState({});
  const [data, setData] = useState([]);

  useEffect(() => {
    getStockData();
  }, []);
  const filteredItems =
    data.filter((row) =>
      row?.project_name?.toLowerCase().includes(searchKeyword.toLowerCase())
    ) || [];

  const getStockData = async (Id) => {
    const projectId = JSON.parse(localStorage?.getItem("projectID"));
    try {
      let payload = {
        project_id: [projectId],
      };

      let responseData = await getRecords(payload, "/dashboard/shortageReport");
      if (responseData.data == 0) {
        setData([]);
      }
      if (responseData.data && responseData.data.length > 0) {
        // responseData.data = responseData?.data.filter((data) => data.stock_qty);

        setData(responseData.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchKeyword(value);
  };

  const FloatValue = (value) => {
    return parseFloat(value)?.toFixed(3);
  };

  const toggleCategory = (index) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleExportData = () => {
    const { columns, rows } = generateCSVData();

    DownloadExcel({
      fileName: "ShortageReport",
      columns: columns,
      data: rows,
      cellColor: false,
    });
  };

  const generateCSVData = () => {
    const columns = [
      { label: "Sr No", key: "srNo" },
      { label: "Project Name", key: "project_name" },
      { label: "Customer Name", key: "customer_name" },
      { label: "Warehouse Type", key: "warehouse_type" },
      { label: "Warehouse Name", key: "warehouse_name" },
      { label: "Order No", key: "order_no" },
      { label: "Invoice No", key: "invoice_no" },

      { label: "Shortage Qty", key: "shortage_qty" },
    ];

    const rows = [];

    filteredItems?.forEach((project, pIndex) => {
      if (pIndex !== 0) {
        // Empty Row Before New Project
        rows.push({
          srNo: "",
          project_name: "",
          customer_name: "",
          warehouse_type: "",
          warehouse_name: "",
          order_no: "",
          invoice_no: "",
          shortage_qty: "",
        });
      }
      rows.push({
        srNo: pIndex + 1,
        project_name: project?.project_name || "N/A",
        customer_name: project?.customer_name || "N/A",
        warehouse_type:
          project?.warehouse_type == 1 ? "Bermad" : "Contractor" || "N/A",
        warehouse_name: project?.warehouse_name || "N/A",
        order_no: project?.order_no || "N/A",
        invoice_no: project?.invoice_no || "N/A",

        shortage_qty: project?.total_shortage_qty || "0",
      });

      rows.push({
        srNo: "",
        project_name: "Sr No",
        customer_name: "Item Code",
        warehouse_type: "Item Description",
        warehouse_name: "shortage QTY",
        order_no: "",
        invoice_no: "",
        shortage_qty: "",
        isHeader: true,
      });

      project?.make_items?.forEach((item, iIndex) => {
        rows.push({
          project_name: iIndex + 1,
          customer_name: item?.make_item_code || "N/A",
          warehouse_type: item?.make_item_desc || "N/A",
          warehouse_name:
            item.make_item_type == 1 ? "-" : item?.total_shortage_qty || "0",
        });

        if (item?.make_item_type == 1 && item?.buy_items) {
          item?.buy_items?.forEach((buyItem, bIndex) => {
            rows.push({
              project_name: `${iIndex + 1}.${bIndex + 1}`,
              customer_name: buyItem?.buy_item_code || "0",
              warehouse_type: buyItem?.buy_item_desc || "N/A",
              warehouse_name: buyItem?.shortage_qty || "0",
            });
          });
        }
      });
    });

    return { columns, rows };
  };
  return (
    <CustomForm
      title={"SHORTAGE REPORT"}
      loadingData={loadingData}
      id={id}
      noBackButton={true}
      noSubmitButton={true}
    >
      <Row className="mt-1">
        <Col lg={12}>
          <div className="">
            <div className="mb-2 d-flex justify-content-between align-items-center text-white">
              <div>
                <div className="app-search d-flex d-lg-inline mt-0 w-25">
                  <div className="position-relative">
                    <input
                      type="search"
                      className="form-control ps-5"
                      placeholder="Search by project name.."
                      value={searchKeyword}
                      onChange={handleInputChange}
                      style={{
                        width: "15rem",
                        padding: "8px 15px",
                        borderRadius: "8px",
                        borderColor: "#D2D2D2",
                        outline: "none",
                        transition: "all 0.3s ease",
                        boxShadow: "none",
                        marginRight: "0.5rem",
                      }}
                    />
                    <span className="ri-search-line"></span>
                  </div>
                </div>
              </div>
              <div>
                <div onClick={handleExportData} className="btn btn-success">
                  Download CSV
                </div>
              </div>
            </div>

            <div className="card-body p-0">
              <div
                className=""
                style={{
                  overflowX: "auto",
                  overflowY: "auto",
                  maxHeight: "1000px",
                  width: "100%",
                  scrollBehavior: "smooth",
                  scrollbarWidth: "thin",
                  msOverflowStyle: "none",
                  zIndex: 0,
                }}
              >
                <table
                  className="table mb-0"
                  style={{
                    border: "1px solid black",
                  }}
                >
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      backgroundColor: "#8AC1E8",
                      borderBottom: "1px solid #cccccc",
                    }}
                  >
                    <tr>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Sr. No
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Project Name
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Customer Name
                      </th>

                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Warehouse Type
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Warehouse Name
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Order No
                      </th>

                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Invoice No
                      </th>

                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Shortage QTY
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredItems?.length > 0 ? (
                      filteredItems.map((row, index) => (
                        <React.Fragment key={index}>
                          <tr
                            style={{
                              verticalAlign: "middle",
                            }}
                            onClick={() => toggleCategory(index)}
                          >
                            <td>{index + 1}</td>
                            <td
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "2px",
                                minWidth: "180px",
                              }}
                            >
                              <div
                                style={{
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  WebkitLineClamp: 2,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  overflowWrap: "break-word",
                                }}
                                title={row?.project_name || "N/A"}
                              >
                                {row?.project_name || "N/A"}
                              </div>
                            </td>
                            <td>{row?.customer_name || "N/A"}</td>
                            <td>
                              {row?.warehouse_type == 1
                                ? "Bermad"
                                : "Contractor" || "N/A"}
                            </td>
                            <td>{row?.warehouse_name || "N/A"}</td>
                            <td
                              style={{
                                width: "150px",
                                minWidth: "150px",
                                maxWidth: "150px",
                              }}
                            >
                              {row?.order_no || "N/A"}
                            </td>
                            <td>{row?.invoice_no || "N/A"}</td>
                            <td>
                              {formatNumber(row?.total_shortage_qty || "0")}
                            </td>
                            <td>
                              {" "}
                              <i
                                className={`mdi mdi-chevron-${
                                  expandedCategories[index] ? "up" : "down"
                                } font-size-18`}
                              ></i>
                            </td>
                          </tr>

                          {expandedCategories[index] && (
                            <>
                              <tr
                                style={{
                                  backgroundColor: "#E5F1FC",

                                  borderBottom: "1px solid #cccccc",
                                }}
                              >
                                <th></th>
                                <th></th>

                                <th style={{ whiteSpace: "nowrap" }}>Sr No</th>
                                <th style={{ whiteSpace: "nowrap" }}>
                                  Item Code
                                </th>
                                <th style={{ whiteSpace: "nowrap" }}>
                                  Item Description
                                </th>

                                <th style={{ whiteSpace: "nowrap" }}>
                                  Shortage QTY
                                </th>
                                <th style={{ whiteSpace: "nowrap" }}></th>
                                <th style={{ whiteSpace: "nowrap" }}></th>
                                <th style={{ whiteSpace: "nowrap" }}></th>
                              </tr>
                              {row.make_items.map((item, iIndex) => (
                                <React.Fragment key={iIndex}>
                                  <tr
                                    style={{
                                      backgroundColor: "#f2f2f2",
                                    }}
                                  >
                                    <td></td>
                                    <td></td>

                                    <td>{iIndex + 1}</td>
                                    <td>{item.make_item_code}</td>
                                    <td>
                                      <div
                                        style={{
                                          display: "-webkit-box",
                                          WebkitBoxOrient: "vertical",
                                          WebkitLineClamp: 2,
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "normal",
                                        }}
                                        title={item.make_item_desc || "N/A"}
                                      >
                                        {item.make_item_desc || "N/A"}
                                      </div>
                                    </td>

                                    <td>
                                      {item.make_item_type == 1
                                        ? "-"
                                        : formatNumber(
                                            item?.total_shortage_qty || "0"
                                          )}
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                  </tr>

                                  {item?.buy_items &&
                                    item?.make_item_type === 1 &&
                                    item?.buy_items.map((buyItem, buyIndex) => (
                                      <tr
                                        key={buyIndex}
                                        style={{
                                          backgroundColor: "#f2f2f2",
                                        }}
                                      >
                                        <td></td>
                                        <td></td>
                                        <td
                                          style={{
                                            paddingLeft: "30px",
                                          }}
                                        >{`${iIndex + 1}.${buyIndex + 1}`}</td>
                                        <td>{buyItem?.buy_item_code}</td>
                                        <td>
                                          <div
                                            style={{
                                              display: "-webkit-box",
                                              WebkitBoxOrient: "vertical",
                                              WebkitLineClamp: 2,
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "normal",
                                            }}
                                            title={
                                              buyItem.buy_item_desc || "N/A"
                                            }
                                          >
                                            {buyItem.buy_item_desc || "N/A"}
                                          </div>
                                        </td>

                                        <td>
                                          {formatNumber(
                                            buyItem?.shortage_qty || "0"
                                          )}
                                        </td>

                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                    ))}
                                </React.Fragment>
                              ))}
                            </>
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center">
                          No data available.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </CustomForm>
  );
};

export default ShortageReport;
